<template>
  <div class="overflow-scroll-y">
    <div class="card-header">
      <h2>다운로드</h2>
      <p v-if="false">작성한 이력서를 PDF 다운로드 합니다.<br>메일전송,다운로드 버튼을 누르면 자동으로 백업됩니다.</p>
      <p style="color:red;" v-if="!$firebase.isAuthenticated">※메일전송, 백업은 로그인이 필요합니다.<br>아래의 화면에서 로그인 해주세요.</p>
    </div>
    <div class="card-content">
      <div class="button-download-pdf" v-if="$firebase.isAuthenticated">

        <div id="completed-buttons" class="bnr_container" v-if="isWeekEndFlag">
          <div id="quickemail" class="bnr_itemWrapper" v-if="false">
            <div class="bnr_item">
              <div class="bnr_txt" style="border-radius: 10px 10px 0 0;">
                <el-button style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !isSendYagiEmailEnabled"
                  @click="$eventHub.$emit('send-special-quickemail', formatId); isSendYagiEmailEnabled = false">
                  <p>클릭 한 번으로 지원기업으로 이력서 발송</p>
                  <br>
                  <h3>야기메일<span>이용하기</span></h3>
                </el-button>
              </div>
              <img src="/kr/resume/static/renew_img/quickemail_button.png" alt="야기메일"
                style="border-radius: 0 0 10px 10px;">
            </div>
          </div>

          <div id="pdf-email" class="bnr_itemWrapper" v-if="$firebase.user.emailVerified">
            <div class="bnr_item">
              <div class="bnr_txt txt">
                <el-button id="pdf-mail-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                  @click="$eventHub.$emit('mail-PDF'); mailPdfEnabled = false">
                  <p>등록한 메일주소로 발송</p>
                  <br>
                  <h3>PDF 발송</h3>
                </el-button>
              </div>
              <p class="bnr_note" v-if="!$firebase.isAuthenticated">※로그인 해주세요.</p>
            </div>
          </div>

          <div id="pdf-download" class="bnr_itemWrapper">
            <div class="bnr_item">
              <div class="bnr_txt txt">
                <el-button id="pdf-dn-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                  @click="$eventHub.$emit('download-PDF'); downloadPdfEnabled = false;">
                  <p>기기에도 보존 가능한</p>
                  <br>
                  <h3>PDF 다운로드</h3>
                </el-button>
              </div>
              <p class="bnr_note">
                <a href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget" target="_blank"
                  rel="nofollow">※안될경우에는 이곳을 클릭</a>
              </p>
            </div>
          </div>

        </div>

        <div id="completed-buttons" class="bnr_container" v-else>

          <div id="quickemail" class="bnr_itemWrapper" v-if="false">
            <div class="bnr_item">
              <img src="/kr/resume/static/renew_img/quickemail_button.png" alt="야기메일">
              <div class="bnr_txt">
                <el-button style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !isSendYagiEmailEnabled"
                  @click="$eventHub.$emit('send-special-quickemail', formatId); isSendYagiEmailEnabled = false">
                  <p>클릭 한 번으로 지원기업으로 이력서 발송</p>
                  <br>
                  <h3>야기메일<span>이용하기</span></h3>
                </el-button>
              </div>
            </div>
          </div>

          <div id="pdf-email" class="bnr_itemWrapper" v-if="false">
            <div class="bnr_item">
              <div class="bnr_txt txt">
                <el-button id="pdf-mail-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                  @click="$eventHub.$emit('mail-PDF'); mailPdfEnabled = false">
                  <p>등록한 메일주소로 발송
                  </p>
                  <br>
                  <h3>PDF 발송</h3>
                </el-button>
              </div>
              <p class="bnr_note" v-if="!$firebase.isAuthenticated">※로그인 해주세요.</p>
            </div>
          </div>

          <div id="pdf-download" class="bnr_itemWrapper" v-if="$site.appFlag != 'b'">
            <div class="bnr_item">
              <div class="bnr_txt txt">
                <el-button id="pdf-dn-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                  @click="$eventHub.$emit('download-PDF'); downloadPdfEnabled = false;">
                  <p>기기에도 보존 가능한</p>
                  <br>
                  <h3>PDF 다운로드</h3>
                </el-button>
              </div>
              <p class="bnr_note">
                <a href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget" target="_blank"
                  rel="nofollow">※안될경우에는 이곳을 클릭</a>
              </p>
            </div>
          </div>

        </div>

      </div>
      <div class="button-download-pdf" v-else>
        <div id="completed-buttons" class="bnr_container">
          <div id="pdf-download" class="bnr_itemWrapper">
            <div class="bnr_item">
              <div class="bnr_txt txt">
                <el-button id="pdf-dn-btn" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                  :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                  @click="$eventHub.$emit('download-PDF'); downloadPdfEnabled = false;">
                  <p>기기에도 보존 가능한</p>
                  <br>
                  <h3>PDF 다운로드</h3>
                </el-button>
              </div>
              <p class="bnr_note">
                <a href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget" target="_blank"
                  rel="nofollow">※안될경우에는 이곳을 클릭</a>
              </p>
            </div>
          </div>

        </div>

      </div>
    </div>
    <div class="card-content">
      <el-collapse v-model="downloadActiveCollapses">

        <el-collapse-item title="염소에게 엽서를 건네다" v-if="false" name="postcard">
          <div><router-link id="footer-link-postcard" :to="{ name: 'postCard' }"><img
                src="/kr/resume/static/img/postcard/postyagi.svg" alt="야기우편"><br>야기운영에 대한 메시지를 기다리고 있습니다.</router-link>
          </div>
        </el-collapse-item>

        <el-collapse-item title="스마트폰에서 이력서를 인쇄하려면" name="print">
          <div>Google 드라이브나 Dropbox 등의 클라우드 스토리지를 사용하거나 Gmail을 통해 「등록한 메일주소로 발송」을 해주세요. 인쇄는 다운로드하여 이용해 주세요.</div>

        </el-collapse-item>
        <el-collapse-item title="다른 기기에서 이어쓰기 위해서는" name="backup">
          <div>다른 기기에서 이어서 작성을 하고 싶은 경우는, Google 계정으로 로그인한뒤 "백업하기"로 데이터를 저장하면 이어서 작성 할 수 있습니다. 덧붙여 비회원 상태에서도, 현재 입력하고 있는
            기기에서는 이어하기로 작성 할 수 있습니다. (브라우저의 데이터를 삭제하거나 기기를 변경했을 경우는 리셋됩니다.)</div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.yagitaku {
  line-height: 25px;
  padding: 15px 0;
  font-weight: bold;
}

.yagitaku_recommend {
  color: #fff;
  background: #E3165C;
  padding: 5px 10px;
  margin-right: 5px;
  border-radius: 50px;
}

.yagitaku_link {
  color: #E3165C;
  border-bottom: 1px solid #E3165C;
}

.create-date_bnr {
  margin: 15px 0;
}

.el-button--success.overwrite.overwrite,
.el-button--primary.overwrite {
  color: #000;
  background: #EFF8F8;
  border: none;
  display: block;
  padding: 0;
  border-radius: 15px;
  white-space: normal;
  line-height: 1.8;
}

.el-button--success.overwrite.overwrite:hover,
.el-button--primary.overwrite:hover {
  background: none;
  color: #000;
}

.addition {
  font-size: .75rem;
  margin: .5rem 0;
}






* {
  list-style: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

img {
  width: 100%;
  vertical-align: bottom;
}

.next_bnr {
  font-size: 1rem;
  color: #004d40;
  text-align: center;
  padding: 1.2rem;
}

.bnr_container {
  display: flex;
  flex-wrap: wrap;
  margin: calc(-30px / 2);
  padding: 30px;
}

.bnr_itemWrapper {
  width: calc(100% / 2 - 30px);
  margin: calc(30px / 2);
}

.bnr_item {
  text-align: center;
}

.bnr_item img {
  border-radius: 10px 10px 0 0;
}

.bnr_txt {
  padding: 15px;
  background: #EFF8F8;
  border-radius: 0 0 10px 10px;
}

.txt {
  border-radius: 10px;
}

.bnr_txt p {
  font-size: 0.8rem;
  font-weight: bold;
  font-family: "M PLUS Rounded 1c";
}

.bnr_txt h3 {
  color: #E3165C;
  font-size: 1.1rem;
  font-weight: bold;
}

.bnr_txt span {
  font-size: 0.8rem;
}

.create-date_txt {
  border-radius: 10px;
}

.bnr_note {
  font-size: 0.8rem;
}

.card-header h1 {
  padding-bottom: 1.5rem;
}

.card-header h2 {
  padding-bottom: 1.5rem;
}

/* タブレット　2カラム */
@media screen and (max-width: 1024px) {
  .bnr_itemWrapper {
    width: calc(100% / 2 - 30px);
  }
}

/* スマホ 1カラム*/
@media screen and (max-width: 599px) {
  .bnr_itemWrapper {
    width: calc(100% / 1 - 30px);
  }
}
</style>

<script>
import LoginForms from '@/components/LoginSpecialForms'
export default {
  props: {
    formatId: {
      type: String
    },
    isSendYagiPostEnabled: {
      type: Boolean
    },
    isSendYagiEmailEnabled: {
      type: Boolean
    },
    mailPdfEnabled: {
      type: Boolean
    },
    downloadPdfEnabled: {
      type: Boolean
    },
    downloadActiveCollapses: {
      type: Array
    }
  },
  components: {
    'login-forms': LoginForms
  },
  data: function () {
    const app = this
    return {
      isWeekEndFlag: true,
      errors: []
    }
  },
  created: function () {

    const nowdate = new Date()
    const date1 = new Date('2023/05/27 00:00:00')
    const date2 = new Date('2023/05/28 23:59:59')
    if (nowdate > date1 && nowdate < date2) {
      this.isWeekEndFlag = true
    } else {
      this.isWeekEndFlag = false
    }

  },
  computed: {
  },
  methods: {
  },
  beforeMount: function () {
  },
  mounted: function () {
  },
  destroyed: function () {
  }
}
</script>
